<header class="student-header">
  <mat-toolbar class="student-toolbar">
    <a
      mat-button
      href="/student/"
      class="qtac-logo-container"
      aria-label="QTAC home"
      data-testid="header-logo"
    >
      <img
        src="/assets/qtaclogo.png"
        alt="QTAC logo"
        class="qtac-logo"
      />
    </a>

    <div class="header__spacer"></div>

    <nav class="header__button-group" aria-label="Site navigation">
      <a
        mat-button
        class="header__button"
        routerLink="/student"
        aria-label="Dashboard"
        data-testid="header-dashboard"
      >
        <div class="header__button-content">
          <mat-icon class="material-icons-outlined">home</mat-icon>
          <span>DASHBOARD</span>
        </div>
      </a>

      <!-- Alerts is not currently available.
      <button
        mat-button
        type="button"
        class="header__button"
        aria-label="Alerts"
        disabled
        data-testid="header-alerts"
      >
        <div class="header__button-content">
          <mat-icon class="material-icons-outlined">notification_important</mat-icon>
          <span>ALERTS</span>
        </div>
      </button>
      -->

      <button
        mat-button
        type="button"
        class="header__button"
        [matMenuTriggerFor]="headerHelpMenu.helpMenu"
        aria-label="Help menu"
        data-testid="header-help"
      >
        <div class="header__button-content">
          <mat-icon>help_outline</mat-icon>
          <span>HELP</span>
        </div>
      </button>
      <app-help-contact-menu #headerHelpMenu></app-help-contact-menu>

      <button
        mat-button
        type="button"
        class="header__button"
        [matMenuTriggerFor]="profileMenu"
        aria-label="Profile menu"
        data-testid="header-profile"
      >
        <div class="header__button-content">
          <mat-icon>account_circle</mat-icon>
          <span>PROFILE</span>
        </div>
      </button>
    </nav>
  </mat-toolbar>
</header>

<mat-menu #profileMenu="matMenu" class="student-profile-menu" xPosition="before" yPosition="below" overlapTrigger="false">
  <div class="profile-menu__user-info" role="none" (click)="$event.stopPropagation()">
    <div class="profile-menu__user-name">{{ studentName }}</div>
    <div class="profile-menu__username"><strong>Email:</strong> {{ studentEmail }}</div>
  </div>
  <div class="divider"></div>

  @for (item of profileMenuItems; track item.action) {
    @if (item.action !== 'update-email' || showEmailUpdate) {
      <a
        mat-menu-item
        [routerLink]="item.routerLink"
        [attr.data-testid]="'profile-' + item.action"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.label }}</span>
      </a>
    }
  }

  <button
    style="text-transform: unset"
    mat-menu-item
    type="button"
    data-test="profile-logout"
    data-testid="profile-logout"
    (click)="logout()"
  >
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
